import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import {
  getCategoryName,
  getSubcategoryName,
} from '../../../../redux/modules/categories';
import ProductThumbnail from '../../../shared/ProductThumbnail/ProductThumbnail';
import Button from '../../../shared/Button/Button';
import { loadProductsByCategory } from '../../../../redux/modules/products';
import ItemSlider from '../../../shared/ItemSlider/ItemSlider';
import Breadcrumb from '../../../shared/Breadcrumb/Breadcrumb';
import { capitalize } from '../../../../utils/strings.js';

import '../Prodotto.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher.js';

class NonDisponibile extends Component {
  state = { ga4Viewed: false, fkmxViewed: false };

  componentDidMount() {
    this.props.loadProductsByCategory(
      {
        category: this.props.category,
        subcategory: this.props.subcategory,
      },
      {
        page: 1,
        sort: '-sales',
      }
    );
  }

  render() {
    const {
      goTo,
      category,
      subcategory,
      discounted,
      categoryName,
      subcategoryName,
    } = this.props;
    const type = category.split('-')[0];

    return (
      <div className="container" style={{ marginTop: '2rem' }}>
        <Helmet
          title={capitalize(type) + ' ' + categoryName + ' ' + subcategoryName}
        />

        <div className="row">
          <div className="col-md-5 image-container">
            <ImageDispatcher
              className="not-available-image"
              src="/static/images/blog_5.png"
            />
          </div>

          <div className="col-md-7 product-not-available">
            <p>Ci scusiamo ma... </p>
            <h1
              className="not-available-title"
              style={{ color: this.props.primaryColor }}
            >
              Il prodotto che stai cercando <br />
              non è più disponibile
            </h1>

            <div className="ctas">
              <Button
                onClick={() => goTo('/')}
                className="btn btn-primary btn-thick"
                style={{ marginTop: 0, marginRight: 0 }}
              >
                Vai alla homepage
              </Button>
              {!!discounted.length && (
                <Button
                  onClick={() => goTo('/prodotti-in-offerta')}
                  className="btn btn-outline btn-thick"
                  style={{ marginTop: 0, marginRight: 0 }}
                >
                  Vai a tutti i prodotti
                </Button>
              )}
            </div>

            <div className="alt-links">
              <p style={{ fontSize: 12, marginBottom: '0.5rem' }}>
                Ricerca altri prodotti nella stessa categoria
              </p>
              <Breadcrumb
                page={type}
                category={category}
                subcategory={subcategory}
              />
            </div>
          </div>

          <div></div>
        </div>

        <div className="item-slider-categories">
          <ItemSlider
            className="item-slider"
            title=" Prodotti della stessa categoria"
            primaryColor={this.props.primaryColor}
            uiVariant={this.props.uiVariantThumbnail}
          >
            {this.props.products.map(product => {
              return (
                <div className="mobile-thumbnail">
                  <ProductThumbnail
                    key={product.id}
                    product={product}
                    list="Similar products slider"
                  />
                </div>
              );
            })}
          </ItemSlider>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    categoryName: getCategoryName(state, ownProps.category),
    subcategoryName: getSubcategoryName(state, ownProps.subcategory),
    primaryColor: state.store.data.loghiTemplate.brandColor,
    products: state.products.data,
    discounted: state.homeProducts.data.discounted,
  };
}

export default connect(mapStateToProps, { loadProductsByCategory })(
  NonDisponibile
);
